// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Navbar from './Components/Navbar';
import Home from './Pages/Home';
import Footer from './Pages/Footer';
import About from './Pages/About';
import Job from './Pages/Jobs';
import Recruiting from './Pages/Recruiting';
import Career from './Pages/Career';
import WhatsAppFloat from './Pages/WhatsAppFloat';
import BackToTop from './Pages/BackToTop';
import Contact from './Pages/Contact';


// Placeholder pages


function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/job" element={<Job />} />
        <Route path="/recruiting" element={<Recruiting />} />
        <Route path="/career" element={<Career />} />
        <Route path="/contact" element={<Contact />} />
       
        {/* <Route path="/Job" element={<Jobs />} />
        <Route path="/register" element={<Register />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/contact" element={<Contact />} />  */}

      </Routes>
      <WhatsAppFloat />
      <BackToTop />
      <Footer />

    </BrowserRouter>

  );
}

export default App;
